import React from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Users, Shield, Award, Crown, Star, Briefcase, Heart, Globe, Target, UserCheck, Building } from "lucide-react";

function Team() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
      <Header />
      
      {/* Hero Section */}
      <div className="pt-40 pb-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-xl border border-white/50 mx-auto max-w-4xl">
            <div className="inline-flex items-center bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <Users className="w-4 h-4 mr-2" />
              Our Leadership
            </div>
            
            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-gray-800">
              Our <span className="text-purple-600">Team</span>
            </h1>
            
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
              Meet the dedicated leaders driving positive change in communities across Uganda
            </p>
          </div>
        </div>
      </div>

      {/* Advisory Board Section */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          {/* Section Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center bg-purple-100 text-purple-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <Shield className="w-4 h-4 mr-2" />
              Strategic Guidance
            </div>
            
            <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">
              Advisory <span className="text-purple-600">Board</span>
            </h2>
            
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/50 max-w-4xl mx-auto mb-12">
              <p className="text-lg text-gray-700 leading-relaxed">
                Our advisory board directs us and advises us strategically in carrying out our work 
                as a community based organization and a service project. We are what we are because of 
                those who advise us and keep us in line, and <strong className="text-purple-700">our advisory 
                board are the real unsung heroes.</strong>
              </p>
            </div>
          </div>

          {/* Advisory Board Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Advisory Member 1 */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/50 hover:shadow-xl transition-all duration-300 hover:scale-105">
              <div className="text-center">
                <div className="relative mb-4 mx-auto w-24 h-24">
                  <img 
                    src="img/default.jpg"
                    alt="HON. AMOS LUGOLOOBI"
                    className="w-24 h-24 rounded-2xl object-cover shadow-lg"
                  />
                  <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center">
                    <Crown className="w-4 h-4 text-white" />
                  </div>
                </div>
                
                <h3 className="text-lg font-bold text-gray-800 mb-2">HON. AMOS LUGOLOOBI</h3>
                <div className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm font-semibold mb-3 inline-block">
                  MP NTENJERU NORTH
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  He is a Member of Parliament, Ntenjeru North Kayunga, Uganda.
                </p>
              </div>
            </div>

            {/* Advisory Member 2 */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/50 hover:shadow-xl transition-all duration-300 hover:scale-105">
              <div className="text-center">
                <div className="relative mb-4 mx-auto w-24 h-24">
                  <img 
                    src="img/default.jpg"
                    alt="GLADYS NAKANKYA"
                    className="w-24 h-24 rounded-2xl object-cover shadow-lg"
                  />
                  <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-gradient-to-r from-pink-500 to-rose-500 rounded-lg flex items-center justify-center">
                    <Heart className="w-4 h-4 text-white" />
                  </div>
                </div>
                
                <h3 className="text-lg font-bold text-gray-800 mb-2">GLADYS NAKANKYA</h3>
                <div className="bg-pink-100 text-pink-800 px-3 py-1 rounded-full text-sm font-semibold mb-3 inline-block">
                  SENIOR CITIZEN
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  She is the Senior citizen in Kayunga.
                </p>
              </div>
            </div>

            {/* Advisory Member 3 */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/50 hover:shadow-xl transition-all duration-300 hover:scale-105">
              <div className="text-center">
                <div className="relative mb-4 mx-auto w-24 h-24">
                  <img 
                    src="img/default.jpg"
                    alt="BGDR. GENERAL KINAALWA"
                    className="w-24 h-24 rounded-2xl object-cover shadow-lg"
                  />
                  <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center">
                    <Shield className="w-4 h-4 text-white" />
                  </div>
                </div>
                
                <h3 className="text-lg font-bold text-gray-800 mb-2">BGDR. GENERAL KINAALWA</h3>
                <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-semibold mb-3 inline-block">
                  UPDF SERVING OFFICER
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  He is a UPDF Serving Officer, Kayunga, Uganda.
                </p>
              </div>
            </div>

            {/* Advisory Member 4 */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/50 hover:shadow-xl transition-all duration-300 hover:scale-105">
              <div className="text-center">
                <div className="relative mb-4 mx-auto w-24 h-24">
                  <img 
                    src="img/default.jpg"
                    alt="MWANJE EDRIS"
                    className="w-24 h-24 rounded-2xl object-cover shadow-lg"
                  />
                  <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center">
                    <Star className="w-4 h-4 text-white" />
                  </div>
                </div>
                
                <h3 className="text-lg font-bold text-gray-800 mb-2">MWANJE EDRIS</h3>
                <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold mb-3 inline-block">
                  SENIOR CITIZEN
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  He is Senior citizen in Kayunga, Uganda.
                </p>
              </div>
            </div>

            {/* Advisory Member 5 */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/50 hover:shadow-xl transition-all duration-300 hover:scale-105">
              <div className="text-center">
                <div className="relative mb-4 mx-auto w-24 h-24">
                  <img 
                    src="img/default.jpg"
                    alt="ARON BUKENYA"
                    className="w-24 h-24 rounded-2xl object-cover shadow-lg"
                  />
                  <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-gradient-to-r from-orange-500 to-amber-500 rounded-lg flex items-center justify-center">
                    <Briefcase className="w-4 h-4 text-white" />
                  </div>
                </div>
                
                <h3 className="text-lg font-bold text-gray-800 mb-2">ARON BUKENYA</h3>
                <div className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm font-semibold mb-3 inline-block">
                  BUSINESSMAN
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  He is the Businessman in Kayunga, Uganda.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Executive Board Section */}
      <div className="py-16 bg-white/40">
        <div className="max-w-7xl mx-auto px-4">
          {/* Section Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <Award className="w-4 h-4 mr-2" />
              Leadership Team
            </div>
            
            <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">
              Executive <span className="text-blue-600">Board Members</span>
            </h2>
            
            <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
              The dedicated professionals who lead our operations and ensure 
              our mission creates meaningful community impact.
            </p>
          </div>

          {/* Executive Board Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Executive Member 1 */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/50 hover:shadow-xl transition-all duration-300 hover:scale-105">
              <div className="text-center">
                <div className="relative mb-4 mx-auto w-32 h-32">
                  <img 
                    src="img/profile1.jpg"
                    alt="Bwogi Joseph Mpagi"
                    className="w-32 h-32 rounded-2xl object-cover shadow-lg"
                  />
                  <div className="absolute -bottom-2 -right-2 w-10 h-10 bg-gradient-to-r from-purple-500 to-indigo-500 rounded-lg flex items-center justify-center">
                    <Crown className="w-5 h-5 text-white" />
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-800 mb-2">Bwogi Joseph Mpagi</h3>
                <div className="bg-purple-100 text-purple-800 px-4 py-2 rounded-full text-sm font-semibold inline-block">
                  President
                </div>
              </div>
            </div>

            {/* Executive Member 2 */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/50 hover:shadow-xl transition-all duration-300 hover:scale-105">
              <div className="text-center">
                <div className="relative mb-4 mx-auto w-32 h-32">
                  <img 
                    src="img/profile5.jpg"
                    alt="Kemigisha Christine"
                    className="w-32 h-32 rounded-2xl object-cover shadow-lg"
                  />
                  <div className="absolute -bottom-2 -right-2 w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg flex items-center justify-center">
                    <UserCheck className="w-5 h-5 text-white" />
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-800 mb-2">Kemigisha Christine</h3>
                <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-semibold inline-block">
                  Vice President
                </div>
              </div>
            </div>

            {/* Executive Member 3 */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/50 hover:shadow-xl transition-all duration-300 hover:scale-105">
              <div className="text-center">
                <div className="relative mb-4 mx-auto w-32 h-32">
                  <img 
                    src="img/profile4.jpg"
                    alt="Sonko Hizir"
                    className="w-32 h-32 rounded-2xl object-cover shadow-lg"
                  />
                  <div className="absolute -bottom-2 -right-2 w-10 h-10 bg-gradient-to-r from-green-500 to-blue-500 rounded-lg flex items-center justify-center">
                    <Award className="w-5 h-5 text-white" />
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-800 mb-2">Sonko Hizir</h3>
                <div className="bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-semibold inline-block">
                  Deputy Vice President
                </div>
              </div>
            </div>

            {/* Executive Member 4 */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/50 hover:shadow-xl transition-all duration-300 hover:scale-105">
              <div className="text-center">
                <div className="relative mb-4 mx-auto w-32 h-32">
                  <img 
                    src="img/profile6.jpg"
                    alt="Kawuuzi Victor"
                    className="w-32 h-32 rounded-2xl object-cover shadow-lg"
                  />
                  <div className="absolute -bottom-2 -right-2 w-10 h-10 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-lg flex items-center justify-center">
                    <Building className="w-5 h-5 text-white" />
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-800 mb-2">Kawuuzi Victor</h3>
                <div className="bg-cyan-100 text-cyan-800 px-4 py-2 rounded-full text-sm font-semibold inline-block">
                  General Secretary
                </div>
              </div>
            </div>

            {/* Executive Member 5 */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/50 hover:shadow-xl transition-all duration-300 hover:scale-105">
              <div className="text-center">
                <div className="relative mb-4 mx-auto w-32 h-32">
                  <img 
                    src="img/profile3.jpg"
                    alt="Kasujja Jackson"
                    className="w-32 h-32 rounded-2xl object-cover shadow-lg"
                  />
                  <div className="absolute -bottom-2 -right-2 w-10 h-10 bg-gradient-to-r from-emerald-500 to-cyan-500 rounded-lg flex items-center justify-center">
                    <Target className="w-5 h-5 text-white" />
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-800 mb-2">Kasujja Jackson</h3>
                <div className="bg-emerald-100 text-emerald-800 px-4 py-2 rounded-full text-sm font-semibold inline-block">
                  Finance Officer
                </div>
              </div>
            </div>

            {/* Executive Member 6 */}
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/50 hover:shadow-xl transition-all duration-300 hover:scale-105">
              <div className="text-center">
                <div className="relative mb-4 mx-auto w-32 h-32">
                  <img 
                    src="img/profile2.jpg"
                    alt="Kiwumulo Joshua"
                    className="w-32 h-32 rounded-2xl object-cover shadow-lg"
                  />
                  <div className="absolute -bottom-2 -right-2 w-10 h-10 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg flex items-center justify-center">
                    <Globe className="w-5 h-5 text-white" />
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-800 mb-2">Kiwumulo Joshua</h3>
                <div className="bg-pink-100 text-pink-800 px-4 py-2 rounded-full text-sm font-semibold inline-block">
                  Spokesperson
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Impact Stats */}
      <div className="py-16 bg-gradient-to-r from-blue-600 to-purple-600">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-8 border border-white/30">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Leadership That Delivers Results
            </h2>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Our combined leadership brings decades of experience in governance, 
              community development, business, and public service.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-white mb-2">200+</div>
                <div className="text-white/80">Team Members</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-white mb-2">6+</div>
                <div className="text-white/80">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-white mb-2">814+</div>
                <div className="text-white/80">Lives Impacted</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Team;